import { Plural, Trans } from "@lingui/macro";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useAuthState } from "@saleor/sdk";
import React from "react";
import { useToggle } from "react-use";

import { GmClientFragment, ProductVariantFragment, useUserDraftCheckoutsQuery } from "@/saleor/api";

import useChannelContext from "../shared/contexts/ChannelContext";
import SelectedClientsDialog from "./SelectedClientsDialog";

export interface CheckoutClientBannerProps {
	onClose?: () => void;
	selectedVariant?: ProductVariantFragment | null | undefined;
}

const CheckoutClientBanner = ({ onClose, selectedVariant }: CheckoutClientBannerProps) => {
	const { authenticated } = useAuthState();
	const { channel } = useChannelContext();
	const { data } = useUserDraftCheckoutsQuery({
		variables: { first: 100, channel, multipleCheckout: false },
		skip: !authenticated,
		fetchPolicy: "network-only",
	});
	const [isOpen, toggleOpen] = useToggle(false);
	if (!authenticated || !data?.userDraftCheckouts) {
		return null;
	}
	const checkouts = data?.userDraftCheckouts?.edges?.map((edge) => edge.node) || [];
	const clients = checkouts.map((c) => c.profile).filter((n) => !!n);
	if (clients.length === 0) {
		return null;
	}

	const closeDialog = () => {
		onClose && onClose();
		toggleOpen();
	};

	const synClients = clients
		.filter((c) => !!c)
		.map((profile) => {
			const res: GmClientFragment = {
				id: profile!.id,
				person: profile!,
				isJointPlanning: false,
				gmClientId: 0,
			};
			return res;
		});
	return (
		<>
			<Alert
				severity="info"
				action={
					<Button
						onClick={toggleOpen}
						startIcon={<RemoveRedEyeIcon />}
						className="capitalize"
					>
						<Trans>Add Recipients</Trans>
					</Button>
				}
			>
				<Plural
					value={clients?.length || 0}
					one="Shopping for # Recipient"
					other="Shopping for # Recipients"
				/>
			</Alert>
			{clients && clients?.length > 0 && (
				<SelectedClientsDialog
					isOpen={isOpen}
					onClose={closeDialog}
					clients={synClients}
					onShopForClients={toggleOpen}
					selectedVariant={selectedVariant}
				/>
			)}
		</>
	);
};

export default CheckoutClientBanner;
